// extracted by mini-css-extract-plugin
export default {"header":"List_header__kEEi1","title":"List_title__hfyoi","description":"List_description__ox5fT","columns":"List_columns__Zxkp-"};